export default defineNuxtPlugin({
  dependsOn: ["session"],
  setup() {
    return {
      provide: {
        authorization: {
          resolveClientUser: (): AppUserSession => {
            return useAppSession().session.value;
          },
        },
      },
    };
  },
});
